var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUsdt = function SvgUsdt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#26A17B",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.485 10.505V8.72h4.095V6H6.43v2.72h4.095v1.784c-3.327.152-5.83.81-5.83 1.596 0 .787 2.504 1.445 5.83 1.598v5.718h2.961v-5.719c3.322-.152 5.82-.809 5.82-1.595 0-.787-2.498-1.444-5.82-1.597m0 2.708v-.001c-.083.005-.513.03-1.468.03-.764 0-1.302-.02-1.491-.03v.002c-2.94-.13-5.135-.64-5.135-1.251 0-.611 2.195-1.121 5.135-1.251v1.993c.193.013.743.046 1.503.046.914 0 1.373-.038 1.457-.046v-1.993c2.934.13 5.124.641 5.124 1.25 0 .608-2.19 1.12-5.124 1.25"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUsdt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "usdt.020fb56887fa3908849cde2c9c018faf.svg";